var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CWrapper',[_c('div',{staticClass:"c-app justify-content-center align-items-center"},[_c('div',{staticClass:"spinner-border text-primary",attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])])])])}
var staticRenderFns = []

export { render, staticRenderFns }